import React, { useState, useEffect } from 'react';
import AccordionBasic from '../components/AccordionBasic';
import ill_docs from '../images/ill-girl-support.png';
import { getFaqs } from '../api/commonApi';

const chatsvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-1.5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    />
  </svg>
);
const callsvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-1.5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
    />
  </svg>
);
const emailsvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 mr-1.5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);
// eslint-disable-next-line react/prop-types
function Help() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const faqs = await getFaqs();
      setFaqs(faqs.data);
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="grid grid-cols-12 gap-6 border-b pb-2 mb-8 border-slate-300">
        <div className="flex flex-col col-span-full xl:col-span-4 bg-white rounded-sm">
          <div className="flex flex-row">
            <h4 className="text-portal-600 text-2xl font-semibold mr-5 mt-2">
              Support center
            </h4>
            <img
              src={ill_docs}
              alt="laundry care icon"
              className=" h-14 w-auto"
            />
          </div>
        </div>
        <div className="flex flex-col col-span-full xl:col-span-8 bg-white  "></div>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <div className="lgg:flex flex-col col-span-full lgg:col-span-4 bg-white rounded-sm">
          <div className="p-5 bg-portal-100 rounded-lg">
            <h4 className="text-center lgg:text-left text-portal-600 text-lg font-medium mr-10">
              Reach Out to Our HR Team Directly
            </h4>
            <div className="text-center lgg:text-left text-sm my-8">
              <h3 className="font-normal text-portalother-100 text-base mb-2">
                Operating Days:
              </h3>
              <div className="font-medium text-base">Monday - Friday</div>
            </div>
            <div className="text-center lgg:text-left text-sm my-8">
              <h3 className="font-normal text-portalother-100 text-base mb-2">
                Operating Times:
              </h3>
              <div className="font-medium text-base">9:00 am - 5:00 pm ET</div>
            </div>
            <div className="text-center lgg:text-left text-sm my-8">
              <h3 className="font-normal text-portalother-100 text-base mb-2">
                Phone:
              </h3>
              <div className="font-medium text-base">
                <a className="text-portal-600" href="tel:8004294332">
                  (800) 429-4332
                </a>
              </div>
            </div>
            <div className="text-center lgg:text-left text-sm my-8">
              <h3 className="font-normal text-portalother-100 text-base mb-2">
                Email:
              </h3>
              <div className="font-medium text-base ">
                <a
                  className=" text-portal-600"
                  href="mailto:hr@laundrycare.biz">
                  hr@laundrycare.biz
                </a>
              </div>
            </div>
          </div>
          {/* <div className="flex justify-evenly space-x-2 text-white text-sm  my-3 rounded-lg">
            <button
              className="bg-portal-800 rounded-lg p-2 px-6 lgg:px-10 text-white text-sm inline-flex"
              onClick={() => (window.location.href = 'tel:8004294332')}>
              {callsvg} Call
            </button>
            <button
              className="bg-portal-800 rounded-lg p-2 px-6 lgg:px-10 text-white text-sm inline-flex"
              onClick={() =>
                (window.location.href = 'mailto:hr@laundrycare.biz')
              }>
              {emailsvg} Email
            </button>
          </div> */}
        </div>
        <div className="flex-col col-span-full lgg:col-span-8 bg-white shadow-lg rounded-sm lgg:flex">
          <div className="lgg:flex flex-col col-span-full lgg:col-span-4 bg-white rounded-sm p-5">
            <h4 className="text-center lgg:text-left text-portal-600 text-xl font-normal mr-10  ">
              Frequently Asked Questions & Answers
            </h4>
            <div className="relative w-full lgg:w-2/5 my-5">
              <label htmlFor="action-search" className="sr-only">
                Search for order
              </label>
              <input
                id="action-search"
                className="form-input focus:border-slate-300 w-full rounded-lg"
                type="search"
                placeholder="Search for order"
              />
              <button
                className="absolute inset-0 left-auto group  bg-portal-100 m-1 rounded-lg"
                type="submit"
                aria-label="Search">
                <svg
                  className="w-4 h-4 shrink-0 fill-current text-portalother-100 group-hover:text-slate-500 ml-3 mr-2"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
                  <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
                </svg>
              </button>
            </div>
            <div>
              {faqs.map((faq, index) => (
                <div className="mb-2" key={index}>
                  <AccordionBasic title={faq.question} status>
                    <p>{faq.answer}</p>
                  </AccordionBasic>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Help;
